import React, { useState, useEffect } from 'react';
import './AnimatedModal.css';
import ReactDOM from 'react-dom';

const AnimatedModal = ({ isOpen, children }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setModalVisible(true);
      document.documentElement.style.overflow = 'hidden';
    } else {
      setClosing(true);
      setTimeout(() => {
        setModalVisible(false);
        setClosing(false);
        document.documentElement.removeAttribute('style');
      }, 300);
    }
  }, [isOpen]);

  if (!modalVisible) {
    return null;
  }

  return ReactDOM.createPortal(
    <React.Fragment>
      <style>{`.swiper{ height: 100%; width: 100%}
      `}</style>
      <idk-div class={`modal-overlay ${closing ? 'closing' : ''}`}>
        <idk-div
          id="idk_modal_container"
          class={`idukki-modal-portal ${closing ? 'slide-out' : 'slide-in'}`}
          style={{ maxWidth: '1000px' }}
        >
          {children}
        </idk-div>
      </idk-div>
    </React.Fragment>,
    document.body,
  );
};

export default AnimatedModal;
